import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@fontsource/cairo/400.css';
import '@fontsource/cairo/500.css';
import '@fontsource/cairo/600.css';
import '@fontsource/cairo/700.css';
import '@fontsource/cairo/800.css';
import '@fontsource/tajawal/400.css';
import '@fontsource/tajawal/500.css';
import '@fontsource/tajawal/700.css';
import '@fontsource/tajawal/800.css';

import '@mantine/core/styles.layer.css';
import '@mantine/dates/styles.layer.css';
import '@mantine/notifications/styles.layer.css';
import '@mantine/dropzone/styles.layer.css';
import '@mantine/spotlight/styles.layer.css';
import 'mantine-datatable/styles.layer.css';
import './styles/global.css';

import './i18n';
import './lib/zod';
import { App } from './App';
import { registerServiceWorker } from './lib/pwaUpdate';
import { resolveShell } from './shells/detect';

const resolution = resolveShell(window.location.hostname, window.location.pathname);
if (resolution.rewriteTo) {
  window.history.replaceState(null, '', `${resolution.rewriteTo}${window.location.search}${window.location.hash}`);
}
document.documentElement.dataset.shell = resolution.shell;

createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <App resolution={resolution} />
  </StrictMode>,
);

// PWA (installable on desktops and phones): updates are picked up without losing work (lib/pwaUpdate)
if (import.meta.env.PROD) registerServiceWorker();
